let sale = document.querySelectorAll('.card__badge .badge--bottom-left')
for (let k = 0;k<sale.length;k++){
    let text = sale[k].innerText
    if (text === 'セール'){
      sale[k].style.color = 'green'
      sale[k].style.backgroundColor = '#f1f1f1'
    }else {
      sale[k].style.color = 'red'
      sale[k].style.backgroundColor = 'black'
    }
}


let sale2 = document.querySelectorAll('.price--large .badge')
for (let k = 0;k<sale2.length;k++){
    let text = sale2[k].innerText
    if (text === 'セール'){
      sale2[k].style.color = 'green'
      sale2[k].style.backgroundColor = '#f1f1f1'
    }else {
      sale2[k].style.color = 'red'
      sale2[k].style.backgroundColor = 'black'
    }
}
